import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  Container,
  AppBar,
  Tabs,
  Tab,
  Typography,
  Box
} from "@material-ui/core";
import ReactPlaceholder from "react-placeholder";
import styles from "./styles";
import TitlePage from "../../TitlePage";
import ProjectSliders from "../ProjectSliders";
import ProjectPlaceholder from "./ProjectPlaceholder";
import { NavLink } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`
  };
}

function ProjectTabBar(props) {
  const { projectCate, classes, fetchProjectById, projects, loading } = props;

  const [value, setValue] = useState(0);

  useEffect(() => {
    if (projectCate.length > 0) {
      const id = projectCate[0].id;
      fetchProjectById({ id, page: 1 });
    }
  }, [fetchProjectById, projectCate]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (value !== newValue) {
      fetchProjectById({ id: projectCate[newValue].id, page: 1 });
    }
  };

  const renderTabHeader = () => {
    if (projectCate && projectCate.length > 0) {
      return projectCate.map((item, index) => {
        return (
          <Tab
            className={`${classes.tabItem} ${
              value === index ? classes.active : ""
            }`}
            key={index}
            label={item.name}
            {...a11yProps(index)}
          />
        );
      });
    }
  };

  const renderTabContent = () => {
    if (projectCate && projectCate.length > 0) {
      return projectCate.map((item, index) => {
        return (
          <TabPanel key={item.id} value={value} index={index}>
            <ReactPlaceholder
              ready={!loading}
              showLoadingAnimation={true}
              customPlaceholder={<ProjectPlaceholder />}
            >
              <ProjectSliders projects={projects} />
              <NavLink className={classes.viewMore} to={`/du-an/${item.alias}`}>
                Xem tất cả dự án
              </NavLink>
            </ReactPlaceholder>
          </TabPanel>
        );
      });
    }
  };

  return (
    <div className={classes.projectTab}>
      <TitlePage
        style={{ textAlign: "center", marginBottom: 30 }}
        name="Một số dự án nổi bật"
        desc="Cập nhật những dự án website, phần mềm chúng tôi đã hoàn thành"
      />

      <Container maxWidth="lg">
        <AppBar position="static" color="default" className={classes.tabBar}>
          <Tabs
            className={classes.TabContents}
            value={value}
            onChange={handleChange}
            // indicatorColor="transparent"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            classes={{ indicator: classes.indicator }}
          >
            {renderTabHeader()}
          </Tabs>
        </AppBar>
      </Container>
      <Container maxWidth="xl">
        {projectCate.length > 0 && renderTabContent()}
      </Container>
    </div>
  );
}

export default withStyles(styles)(ProjectTabBar);
